export default __webpack_public_path__ + "static/char-thumb-59-75bdc56da3f609d4f390f4b85bff192f.png";